<app-page-header headerImage="{{ headerImage }}"></app-page-header>

<div class="invoice-details">
  <div class="invoice-details_title">
    <h1 class="mat-display-small">Invoice: {{ invoiceNumber }}</h1>
    <h2 class="mat-display-medium bddc-light-blue margin-bottom_20">
      {{ invoiceDate }}
    </h2>
  </div>

  <div class="invoice-details_title">
    <span
      [class.state_due]="invoiceState === 'Due'"
      [class.state_partial]="invoiceState === 'Partially Paid' || invoiceState === 'Payment scheduled'"
      [class.state_paid]="invoiceState === 'Paid'"
    >
      {{ invoiceState }}
    </span>
  </div>

  <div class="invoice-details-billing_container">
    <mat-card class="invoice-card margin-bottom_30">
      <mat-list role="list">
        @if (invoiceDetailsState === '' && hasData) { @for (invoiceDetail of invoiceDetails | keyvalue; track
        invoiceDetail) { @for (row of invoiceDetail.value; track row) {
        <mat-list-item
          class="list-item-borders height_72 margin-left_20 margin-right_20"
          [ngClass]="row.description.length > 17 ? 'extra-height' : ''"
        >
          <div class="single-row-layout">
            <div class="invoice-details-billing_content-column-description">
              @if (hasDogSpecificRows(invoiceDetails)) {
              <h3>{{ getDisplayName(invoiceDetail.key) }}</h3>
              }
              <div [innerHTML]="row.description" class="gray-blue_bold"></div>
              <div class="gray-blue height_18">{{ row.date }}</div>
            </div>
            <div class="bddc-light-blue_bold">
              <span>&pound;{{ row.amountExclVat }}</span>
            </div>
          </div>
        </mat-list-item>
        } }
        <mat-list-item class="list-item-borders height_83 bottom-border_none">
          <div class="single-row-layout">
            <div
              class="invoice-details-billing_content-column"
              [ngClass]="{ 'font-size_15': true }"
              [ngClass.lt-md]="{ 'font-size_16': true }"
            >
              <div class="bddc-light-blue_bold vat">VAT</div>
              <div class="bddc-light-blue_bold font-size_15">Invoice total</div>
            </div>
            <div class="invoice-details-billing_content-column content-right bddc-light-blue_bold">
              <span class="margin-bottom_11">&pound;{{ invoiceVatTotal }}</span>
              <span>&pound;{{ invoiceTotal }}</span>
            </div>
          </div>
        </mat-list-item>
        <mat-list-item
          class="list-item-borders height_72 amount-due-style_left amount-due-style_right amount-due-style_background-color bottom-border_none"
        >
          <div class="invoice-details-billing_content">
            <h2 class="mat-display-medium">Amount due</h2>
            <h2 class="mat-display-medium" [ngClass.lt-md]="{ 'invoice-total-style': true }">
              &pound; {{ invoiceOutstanding }}
            </h2>
          </div>
        </mat-list-item>
        } @if (!hasData) {
        <div class="u-flex-center">
          <mat-spinner color="primary" diameter="50"></mat-spinner>
        </div>
        } @if (invoiceDetailsState !== '') {
        <div class="invoice-card_blank">
          <p class="mat-body-medium">{{ invoiceDetailsState }}</p>
        </div>
        }
      </mat-list>
    </mat-card>

    <div class="invoice-details-billing_footer">
      @if (downloadLoading) {
      <button mat-raised-button [disabled]="true" class="rounded u-margin-left_10">
        <div class="u-flex-center">
          <mat-spinner color="primary" diameter="30"></mat-spinner>
        </div>
      </button>
      } @if (!downloadLoading) {
      <button
        mat-raised-button
        [disabled]="downloadLoading"
        class="rounded bddc-dark-blue margin-right_10 mat-secondary"
        (click)="getDownloadFile()"
      >
        DOWNLOAD
      </button>
      } @if (!invoicePaid && !directDebitPaymentScheduled) { @if (loadingStripe) {
      <button mat-raised-button class="rounded u-margin-left_10">
        <div class="u-flex-center">
          <mat-spinner color="primary" diameter="30"></mat-spinner>
        </div>
      </button>
      } @if (!loadingStripe && !hideButton) {
      <button mat-raised-button color="primary" class="rounded u-margin-left_10" (click)="payInvoice()">
        PAY INVOICE
      </button>
      } }
    </div>
  </div>
</div>
